import { useCallback, useMemo } from 'react';

import { useDefaultEvents, useGrid } from '@Components/Grid';

export default function useEvents() {
  const { store: { collection: { save } }, handleRefresh } = useGrid()
  const { handleDeleteEntry, handleUpdateEntry } = useDefaultEvents()

  const handleDuplicateEntry = useCallback(async row => {
    row.id = null
    if (Array.isArray(row.forms)) {
      row.forms = row.forms.map(form => form.id)
    }
    await save(row)
    await handleRefresh()
  }, [save, handleRefresh])

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
    handleDuplicateEntry,
  }), [handleUpdateEntry, handleDeleteEntry, handleDuplicateEntry])
}
